export default __webpack_public_path__ + "static/media/draft-outline-16px.e543b9ce.svg";